<form [formGroup]="emailForm">
  <div class="d-flex-flex-column p-3">
    <div class="col-6">
      <rmp-text-area
        [formGroup]="emailForm"
        formControlName="subject"
        [label]="subjectTitle"
        [characterLimit]="maxEmailSubjectChars"
        [isRequired]="true"
      ></rmp-text-area>
    </div>
    <div class="n-input-group">
      <label><required-indicator></required-indicator>{{ bodyTitle }}</label>
      <rmp-html-editor
        [formGroup]="emailForm"
        formControlName="body"
        [label]="bodyTitle"
        maxWidth="100%"
        minWidth="100%"
        [maxContentLength]="maxEmailChars"
      ></rmp-html-editor>
    </div>
  </div>
</form>
